import React from "react";
import heroImage from "../../assets/photo_bg/pates.png";
import { useLanguage } from "../../contexts/LanguageContext.jsx";

/**
 * Colonne gauche de la page auth — design aligné VisitorHome (slate + orange/ambre)
 */
const AuthPageHero = () => {
  const { t } = useLanguage();
  const STATS = [
    { value: "10K+", label: t("activeUsers") },
    { value: "50K+", label: t("recipes") },
    { value: "4.9", label: t("reviews"), unit: "★" },
  ];

  return (
    <div className="hidden md:flex flex-col text-white animate-fade-in-left max-w-lg">
      {/* Bloc logo + titre en ligne */}
      <div className="flex items-center gap-4 mb-8">
        <div className="relative flex-shrink-0">
          <div className="absolute inset-0 bg-orange-400/40 blur-xl rounded-full" />
          <img
            src="/logojes.png"
            alt="JesCook"
            className="relative w-16 h-16 object-contain drop-shadow-lg"
          />
        </div>
        <div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-white drop-shadow-sm">
            JesCook
          </h1>
          <p className="text-amber-200/90 text-sm font-medium mt-0.5">
            {t("appDescription")}
          </p>
        </div>
      </div>

      {/* Citation / accroche */}
      <blockquote className="border-l-4 border-orange-400/80 pl-5 py-2 mb-8 text-slate-200/95 text-lg font-medium italic">
        {t("discoverCreations")}
      </blockquote>

      {/* Image hero — cadre simple, overlay orange/ambre */}
      <div className="relative overflow-hidden rounded-xl shadow-2xl ring-1 ring-white/10 aspect-[4/3] mb-8">
        <img
          src={heroImage}
          alt="Cuisine"
          className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-white font-semibold text-sm drop-shadow-md">
            {t("communitySubtitle")}
          </p>
        </div>
      </div>

      {/* Stats — style pill / inline */}
      <div className="flex flex-wrap gap-3">
        {STATS.map((stat, i) => (
          <div
            key={i}
            className="inline-flex items-baseline gap-1.5 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2.5 border border-white/15 hover:bg-white/15 transition-colors duration-200"
          >
            <span className="text-xl font-bold text-white tabular-nums">
              {stat.value}
              {stat.unit ?? ""}
            </span>
            <span className="text-xs font-medium text-amber-200/90">
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuthPageHero;
